import { IS_BROWSER_ENVIRONMENT, MfsError, MfsStatusCode } from '@metaos/mfs-telemetry';
import { STORAGE_CAPACITY_EXCEEDED_ERROR, STORAGE_CAPACITY_EXCEEDED_FIREFOX_ERROR } from './constants';
import { logger } from './logger';
/**
 * Utility method that checks if the error is because of storage capacity exceeded in multiple browsers. If new guidance
 * is provided in the web storage API, please update this method
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasCapacityExceeded(error) {
    if (error instanceof DOMException &&
        // browsers except Firefox
        (error.code === 22 ||
            // Firefox
            error.code === 1014 ||
            // test name field too, because code might not be present sometimes
            // browsers except Firefox
            error.name === STORAGE_CAPACITY_EXCEEDED_ERROR ||
            // Firefox
            error.name === STORAGE_CAPACITY_EXCEEDED_FIREFOX_ERROR)) {
        return true;
    }
    return false;
}
/**
 * Utility method to ensure that local storage is accessed only in browser and that local storage instance is valid and
 * available. Returns a valid local storage instance if errors are not thrown
 */
export function getLocalStorage() {
    const notBrowserErr = getLocalStoreNotBrowserError();
    const storageUnavailableErr = getLocalStoreUnavailableError();
    if (!IS_BROWSER_ENVIRONMENT) {
        logger.logError(`LocalStoreNotBrowserError`, notBrowserErr.statusCode, { message: notBrowserErr.message }, `getLocalStorage`);
        throw notBrowserErr;
    }
    const storage = window.localStorage;
    if (!storage) {
        logger.logError(`LocalStoreUnavailableError`, storageUnavailableErr.statusCode, { message: storageUnavailableErr.message }, `getLocalStorage`);
        throw storageUnavailableErr;
    }
    return storage;
}
/** Error indicating that the local store capacity has exceeded. Typically, the limit is 5MB for most browsers */
export function getLocalStoreCapacityExceededError() {
    return new MfsError(`Storage capacity in local storage has exceeded. Cannot add/update the new item`, MfsStatusCode.NotAllowed);
}
/** Error indicating that the environment is not browser */
export function getLocalStoreNotBrowserError() {
    return new MfsError(`Environment is not a browser`, MfsStatusCode.NotAllowed);
}
/** Error indicating that the local storage isn't available in this browser */
export function getLocalStoreUnavailableError() {
    return new MfsError(`Local storage is not defined for this browser`, MfsStatusCode.NotFound);
}
//# sourceMappingURL=utility.js.map